import { InputGroup, FormControl, Alert } from "react-bootstrap";

import { Footer } from "../components/include/Footer";
import Title from "../components/common/Title";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  isLoading,
  isError,
  isAuthenticated,
  isMessage,
  isData,
  isPermission,
  isRole,
} from "../redux/selectors/authSelector";
import { login, loginClear } from "../redux/actions/authActions";
import { Link, useNavigate } from "react-router-dom";
import { message } from "../redux/actions/toastActions";
import Logo from "../assets/Icons/Frame 476.png";
import "../styles/Login.scss";
import emailIcon from "../assets/Icons/email.svg";
import lockIcon from "../assets/Icons/lock.svg";
import { IoEyeOutline, IoEyeOffOutline } from "react-icons/io5";

const Login = () => {
  const [username, setusername] = useState(
    process.env.NODE_ENV !== "production" ? "devadmin" : ""
  );
  const [password, setpassword] = useState(
    process.env.NODE_ENV !== "production" ? "123456" : ""
  );
  const [showPassword, setShowPassword] = useState(false);
  const [remember, setremember] = useState(false);
  // const [IPAddress, setIPAddress] = useState('')
  const loader = useSelector(isLoading);
  const Authenticated = useSelector(isAuthenticated);
  const Data = useSelector(isData);
  const loginMessage = useSelector(isMessage);
  const errorMsg = useSelector(isError);
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const permissions = useSelector(isPermission);
  let role = useSelector(isRole);
  const is_verified = useSelector((state) => state.auth?.data?.user?.school_id?.is_school_verified);
  

  const onLoginAction = async (event) => {
    event.preventDefault();
    dispatch(
      login({ username: username, password: password, remember: remember })
    );
  };

  useEffect(() => {
    dispatch(loginClear());
  }, []);

  useEffect(() => {
    if (Authenticated) {
      if (permissions?.length > 0) {
        const firstPermission = permissions[0];
        const moduleName = firstPermission.split("_").slice(1).join("_"); // e.g., "Education"
        if (moduleName) {
          navigate(`/${moduleName.toLowerCase().replaceAll("_", "-")}`);
        }
      } else if (role == "schooladmin") {
        if(is_verified){

          navigate("/dashboard");
        }else{
          navigate("/profile")
        }
      } else {
        navigate("/admin-dashboard");
      }
      dispatch(message(loginMessage));
      
    }
  }, [Authenticated, permissions]);
  return (
    <>
      <Title name="Login" />
      {console.log("errorMsg =>", errorMsg)}
      <div className="account-pages loginBackground" style={{ paddingTop: "8%" }}>
        <div className="container ">
          <div className="row justify-content-start">
            <div className="col-md-8 col-lg-6 col-xl-5">
              {errorMsg && <Alert variant="danger">{errorMsg}</Alert>}
              <div
                className="card overflow-hidden"
                style={{ backgroundColor: "white" }}
              >
                <div className="card-body pt-0">
                  <h3 className="text-center mt-4">
                    <a href="/" className="logo logo-admin">
                      <img src={Logo} height="100" alt="logo"  className=" mb-4" style={{ width: "220px" }} />
                    </a>
                    <h3>Sign In</h3>

                    <p className="sub-title">
                      Seamless School Management Starts with a Sign In
                    </p>
                  </h3>
                  <div className="login-container">
                    <form
                      className="login-form"
                      action="/"
                      onSubmit={onLoginAction}
                    >
                      <label>
                        Email ID<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon"><img src={emailIcon} /></span>
                        <input
                          type="text"
                          value={username}
                          autoComplete="current-email"
                          onChange={(e) => setusername(e.target.value)}
                          placeholder="Enter Your Email ID"
                          required
                        />
                      </div>

                      <label>
                        Password<span className="required">*</span>
                      </label>
                      <div className="input-group">
                        <span className="icon"><img src={lockIcon} /></span>
                        <input
                          type={showPassword ? "text" : "password"}
                          value={password}
                          autoComplete="current-password"
                          onChange={(e) => setpassword(e.target.value)}
                          placeholder="Enter Your Password"
                        />
                        <span
                          className="toggle"
                          onClick={() => setShowPassword(!showPassword)}
                        >
                          {showPassword ? <IoEyeOutline className="icon" /> : <IoEyeOffOutline className="icon" />}
                        </span>
                      </div>

                      <Link to="/forgot-password" className="forgot-password">Forgot Password?</Link>

                      <button type="submit" className="sign-in-button" disabled={loader}>
                        {loader ? "Please wait..." : "Sign In"}
                      </button>
                    </form>

                    <p className="text-center pt-3 font-sm">
                      Don’t have an Account? <Link to="/school-signUp" className="forgot-password" >Sign Up</Link >{" "}
                    </p>
                  </div>
                </div>
              </div>
              {/* <div className="mt-5 text-center">
                <Footer />
              </div> */}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Login;

// <div className="">
//   <form className="form-horizontal mt-4" action="/" onSubmit={onLoginAction}>
//     <InputGroup className="mb-3" style={{ backgroundColor: "#fff" }}>
//       <InputGroup.Text>
//         <i className="mdi mdi-account" style={{ color: "rgb(24, 33, 82)" }} />
//       </InputGroup.Text>
//       <FormControl
//         type="text"
//         value={username}
//         autoComplete="current-email"
//         onChange={(e) => setusername(e.target.value)}
//         placeholder="Enter Username"
//         required
//       />
//     </InputGroup>

//     <InputGroup className="mb-3" style={{ backgroundColor: "#fff" }}>
//       <InputGroup.Text>
//         <i className="mdi mdi-key" style={{ color: "rgb(24, 33, 82)" }} />
//       </InputGroup.Text>
//       <FormControl
//         type="password"
//         value={password}
//         autoComplete="current-password"
//         onChange={(e) => setpassword(e.target.value)}
//         placeholder="Enter Password"
//         required
//       />
//     </InputGroup>
//     <div className="form-group row mt-4">
//       <div className="col-12 d-none">
//         <div className="custom-control custom-checkbox">
//           <input
//             type="checkbox"
//             onChange={(e) => setremember(e.target.checked)}
//             className="custom-control-input"
//             id="customControlInline"
//           />
//           <label className="custom-control-label" htmlFor="customControlInline">
//             Remember me
//           </label>
//         </div>
//       </div>
//     </div>
//     <div className="form-group row mt-4">
//       <div className="col-12 text-center">
//         <button
//           className="btn w-md waves-effect waves-light btn_pink"
//           type="submit"
//           disabled={loader}
//         >
//           {loader ? "Please wait..." : "Log In"}
//         </button>
//       </div>
//     </div>
//     <div className="form-group mb-0 row">
//       {/* TEMPORARY COMMENTED
//                         <div className="col-12 mt-12">
//                           <Link to="/forgot-password" className="" style={{color:'black'}}>
//                             <i className="mdi mdi-lock"></i> Forgot your password?
//                           </Link>
//                         </div> */}
//       {/* <div className="col-6 mt-4">
//                           <Link to="/forgot-username" className="text-muted"><i className="mdi mdi-account-alert"></i> Forgot your username?</Link>
//                       </div> */}
//     </div>
//   </form>
// </div>;
